import { useEffect, useState } from 'react';
import Footer from '../../../Components-2/Footer';
import Header from '../../../Components-2/Header/Header';
import Sidebar1 from '../../../Components-2/Sidebar1';
import Complaint from './Complaint';
import ViewQuery from './ViewQuery';
import Query from './Query';

function CustomerQuery() {
  // Get permissions from localStorage
  const permissions = JSON.parse(localStorage.getItem("Login")) || {};
  const has = (key) => permissions[key] === 1;

  // Define tabs with permissions

  const tabs = [
    { id: 'upload', label: 'Query', component: <Query />, permission: 'ComplaintQuery' }, // A
    { id: 'delivered', label: 'Complaint', component: <Complaint />, permission: 'ComplaintRegister' },
    { id: 'undelivered', label: 'View Complaint Status', component: <ViewQuery />, permission: 'ViewComplaintStatus' },
   
  ];

  // Filter tabs based on permissions
  const visibleTabs = tabs.filter(tab => has(tab.permission));

  const [activeTab, setActiveTab] = useState(visibleTabs[0]?.id || null);

  useEffect(() => {
    if (!activeTab && visibleTabs.length > 0) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  return (
    <>
      <Header />
      <Sidebar1 />

      <div id="main-body">
        <div className="container">

          {/* Tab radios */}
          {visibleTabs.map(tab => (
            <input
              key={tab.id}
              type="radio"
              name="slider"
              id={tab.id}
              checked={activeTab === tab.id}
              onChange={() => setActiveTab(tab.id)}
            />
          ))}

          {/* Tab labels */}
          <nav>
            {visibleTabs.map(tab => (
              <label key={tab.id} htmlFor={tab.id} className={tab.id}>
                {tab.label}
              </label>
            ))}

            {/* Slider */}
            <div className="slider"
              style={{
                width: `${100 / visibleTabs.length}%`,
                left: `${visibleTabs.findIndex(t => t.id === activeTab) * (100 / visibleTabs.length)}%`
              }}
            ></div>
          </nav>

          {/* Tab content */}
          <section>
            {visibleTabs.map(tab => (
              <div
                key={tab.id}
                className={`content content-${tab.id} ${activeTab === tab.id ? 'active' : ''}`}
              >
                {tab.component}
              </div>
            ))}
          </section>

        </div>
        <Footer />
      </div>
    </>
  );
}

export default CustomerQuery;
